module.exports = __webpack_public_path__ + "static/people_pop3-1c3ba186716aebcfa1dd1c24d91e6839.png";